import React from 'react';
import ReactMarkdown from 'react-markdown';

import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';

import './MarkdownContent.scss';
// import { AirtableImageField } from 'airtable';
import AirtableImage from '../core/AirtableImage';
import { AirtableImageField } from "@irvin-group/airtable-data-types";

/**
 * factory to create a React component that will transform a img referencing an
 * attachment into a proper AirtableImage
 */
const createMappedImageComponent = (attachments: AirtableImageField) => (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
  const { src } = props;
  const attachment = attachments.find(a => a.filename === src);

  if (!attachment) {
    console.warn(`could not find attachment ${src} referenced in markdown`);
    return <img { ...props } />;
  }

  if (!attachment.thumbnails) {
    console.warn(`attachment ${src} does not have thumbnails. Is it not an image?`);
    return <img { ...props } />;
  }

  return (
    <AirtableImage
      image={ attachment }
      thumbnail="large"
      render={ url => <img { ...props } src={ url } /> } />
  );

};

type Props = {

  /** markdown source */
  source?: string

  /** attachments for the markdown source */
  attachments?: AirtableImageField

  /**
   * flag to pull the content from the MainContent row of the current page
   * instead of using the source and attachments props
   */
  mainContent?: boolean
}

export default class MarkdownContent extends React.Component<Props> {

  render()
  {
    if (this.props.source) {
      return this._render(this.props.source, this.props.attachments || []);
    }

    if (!this.props.mainContent) {
      throw new Error('must set mainContent flag if not providing source and attachments directly');
    }

    return (
      <AirtableDataConsumer>
        { data => data && this._renderMainContent(data) }
      </AirtableDataConsumer>
    );
  }

  _renderMainContent(data: AirtableContextData)
  {
    const mainContent = data.pageParameters.getSingle('MainContent');

    const source = mainContent.Content;
    const attachments = mainContent.Image;

    return this._render(source, attachments);
  }

  _render(source: string, attachments: AirtableImageField)
  {
    return (
      <div className="markdown-content">
        <section className="f6 f5-ns lh-copy flex-auto">
        <ReactMarkdown
          components={{
            img: createMappedImageComponent(attachments),
            a: ({ node, ...props }) => {
              if (props.href?.indexOf('http') === 0) {
                return (
                  <a href={props.href} target="_blank" rel="noreferrer" {...props}>
                    {props.children}
                  </a>
                )
              }
              return (
                <a href={props.href} {...props}>
                  {props.children}
                </a>
              )
            }
          }}
          children={source}
        />
        </section>
      </div>
    );
  }

}